export default import.meta.ROLLDOWN_FILE_URL_ko4DP3E3oMV7GxqZL0NGuQ